angular
  .module("digitalLeasing.module")
  .component("privacy", {
    templateUrl: "ng/components/digitalLeasing/acceptance/privacy/privacy.view.html",
    bindings: {
      appCustomer: "<",
      privacy: "=",
      formaGiuridica: "<",
      idNumber: "<",
      isFinancial: "@",
      onPrivacyOk: "&?",
      onPrivacyNotOk: "&?",
      noDownload: '<',
      titleOnlyAuth: '<',
      model: '<',
      cf: "<",
      piva: "<",
      isDigital: "<",
      snapshot: '<',
      portalRunned: '<',
      updatePrivacy: "&",
      ndg: "<"
    },
    controllerAs: "privacyCtrl",
    controller: function privacyController(
      $rootScope,
      $timeout,
      $configService,
      $giuridicVersion,
      $privacyService,
      $portalService,
      FileUploader,
      $instantService,
      $download
    ) {
      var self = this;

      self.$giuridicVersion = $giuridicVersion;
      (self.privacy = {
        downloaded: false,
        documentoPrivacyFirmato: {},
        moduleCode: "",
        subscritionDate: null,
        validityEndDate: null,
        listaConsensi: [],
        writeToNsil: false,
        privacyInfoChecked: null,
        index: null
      }),
        (self.loadingStatus = {
          uploading: false,
          loadingDataFromCerved: false,
          savedDataFromCerved: false,
          loading: false,
          loadingAddressesList: false,
          loadingPfList: false,
          insertingContract: false
        });

      self.$onInit = function () {
        self.$portalService = $portalService;
        self.validationObj = {
          documentDate: {
            disabledDays: [0],
            disabledDates: [
              "01-01",
              "06-01",
              "25-04",
              "01-05",
              "02-06",
              "15-08",
              "01-11",
              "08-12",
              "25-12",
              "26-12"
            ]
          }
        }

        self.noDownload = self.noDownload || false;
        self.titleOnlyAuth = self.titleOnlyAuth || false;
        self.privacy = self.privacy || null;
        self.formaGiuridica = self.formaGiuridica || null;
        self.idNumber = self.idNumber || null;
        self.progresso = 0;
        self.visualProgBar = false;
        self.codFiscale = $configService.getUser().identifier;


        if (!$portalService.isAru()) {

          $privacyService.getPrivacyDataDigital(self.cf, self.piva, self.formaGiuridica, self.ndg)
            .then(function (response) {
              if (self.snapshot && self.privacy.dataSottoscrizione) {
                response.privacy.valid = false;
                response.privacy.dataSottoscrizione = self.privacy.dataSottoscrizione ? self.privacy.dataSottoscrizione : response.privacy.validFrom;
              }
              self.privacy = response.privacy;
              self.updatePrivacy({
                privacy: self.privacy
              });

              self.checkPrivacy();
              mapConsensi();
            })
            .catch(function (error) {
              console.log("errore nella chiamata al servizio delle domande della privacy", error);
              self.checkPrivacy();
            })


          self.checkPrivacy();
        };

        if (self.snapshot) {
          self.privacy.privacyInfoChecked = true;
        }


      }


      self.uploadDataFunc = function (item, index, privacy) {
        var document =
          arguments.length > 3 && arguments[3] !== undefined ?
            arguments[3] :
            false;
        if (item) {
          self.uploadData = item;
        }
        self.isPrivacyUpload = privacy;
        self.uploadDocumenti = document;
        self.currentCodeTypeNameIndex = index;
      };

      self.uploader = new FileUploader({
        url: "",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
          "App-Name": $rootScope.portalName
        }
      });

      self.finalUpload = function (item) {
        console.log("calling finalUpload");
        self.folderPath = "" + new Date().getTime();
        var url;
        if (self.isPrivacyUpload) {
          url =
            $configService.getAppConfig().url +
            "/simulator/upload/service-infos/" +
            encodeURIComponent(self.idNumber) +
            "/PRIVACY/";
        } else {
          url =
            $configService.getAppConfig().url +
            "/simulator/upload/service-infos/" +
            encodeURIComponent(self.idNumber) +
            "/" +
            item.code +
            "/";
        }
        for (var int = 0; int < self.uploader.queue.length; int++) {
          self.uploader.queue[int].url = url;
        }
        self.loadingStatus.uploading = true;
        self.uploader.uploadAll();
      };

      self.generateDownloadLink = function (filename, directory) {
        var url = "/simulator/download/service-infos/" +
          encodeURIComponent(self.idNumber) +
          "/" +
          encodeURIComponent(directory) +
          "/" +
          encodeURIComponent(filename) + "/"

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };

      self.generatePrivacyDownloadLink = function () {

        var url = '/uni/download/service-infos/' +
          encodeURIComponent(self.privacy.docDownloadCode) + '/'

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };


      self.uploader.onWhenAddingFileFailed = function (
        item /*{File|FileLikeObject}*/,
        filter,
        options
      ) {
        console.info("onWhenAddingFileFailed", item, filter, options);
      };

      self.uploader.onAfterAddingFile = function (fileItem) {
        console.log("fileItem", fileItem);
        if (fileItem.file.size > 26214400) {
          $rootScope.$broadcast("addAlert", {
            text: "MAXIMUM_FILE_SIZE_EXCEEDED"
          });
          fileItem.remove();
          $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
        }
        var fileName = fileItem.file.name;
        if (
          fileName.toLowerCase().indexOf(".pdf") > -1 ||
          fileName.toLowerCase().indexOf(".png") > -1 ||
          fileName.toLowerCase().indexOf(".jpg") > -1 ||
          fileName.toLowerCase().indexOf(".jpeg") > -1 ||
          fileName.toLowerCase().indexOf(".p7m") > -1
        ) {
          self.uploader.queue[0].progress = 100;
          self.visualProgBar = true;
          $timeout(function () {
            self.progresso = 100;
          }, 50);
          $timeout(function () {
            self.visualProgBar = false;
          }, 4000);
        } else {
          fileItem.remove();
          $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
          $rootScope.$broadcast("addAlert", {
            text: "FORMAT_NOT_SUPPORTED"
          });
        }
      };

      self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
      };

      self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
      };

      self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
      };

      self.uploader.onProgressAll = function (progress) { };

      self.uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        self.loadingStatus.uploading = false;
      };

      self.uploader.onErrorItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.info("onErrorItem", fileItem, response, status, headers);
        $rootScope.$broadcast("addAlert", {
          text: "ERROR_UPLOADING_FILE"
        });
        fileItem.remove();
        $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
      };

      self.uploader.onCancelItem = function (
        fileItem,
        response,
        status,
        headers
      ) { };

      self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
      ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (response.success) {
          //alert("ok!");
          console.log(fileItem);
          if (self.isPrivacyUpload) {
            self.privacy.documentoPrivacyFirmato = {
              selected: false,
              nameFile: response.fileName
            };
          }
        }
        self.uploader.queue = [];
        self.checkPrivacy();
      };

      self.uploader.onCompleteAll = function () {
        console.info("onCompleteAll");
        // $timeout(function () {
        //   self.visualProgBar = false;
        // }, 3000);
        self.uploadCompleted = true;
      };

      self.consensiPrivacy = function () {
        self.esito = true;
        if (self.featureService.NewPrivacy()) {
          self.raccoltaInfo.privacy.listaConsensi &&
            self.raccoltaInfo.privacy.listaConsensi
              .filter(function (consenso) {
                return consenso.obbligatorio;
              })
              .forEach(function (consensoObbligatorio) {
                if (
                  consensoObbligatorio.esito == "false" ||
                  consensoObbligatorio.esito == false
                ) {
                  self.esito = false;
                }
              });
        }
        return self.esito;
      };


      self.deletePrivacyDocument = function () {
        self.progresso = 100;
        self.visualProgBar = true;
        $timeout(function () {
          self.progresso = 0;

        }, 200);

        $timeout(function () {
          self.visualProgBar = false;
        }, 4000);

        var documentRow =
          arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        self.privacy.documentoPrivacyFirmato = {};
        self.checkPrivacy();

      };

      self.check = function (el) {
        el.selected = !el.selected;
      };

      self.checkPrivacy = function () {
        var allRadioChecked = self.privacy.listaConsensi &&
          self.privacy.listaConsensi
            .every(function (domanda) {
              return domanda.checked === true;
            })
        if (!self.privacy) {
          return;
        }

        if (!self.isFinancial) {
          if (self.isDigital && !$portalService.isAru()) {

            var ok =
              self.privacy &&
              self.privacy.privacyInfoChecked &&
              allRadioChecked &&
              !!self.privacy.dataSottoscrizione &&
              self.privacy.listaConsensi &&
              self.privacy.listaConsensi
                .filter(function (consenso) {
                  return !!consenso.obbligatorio;
                })
                .every(function (consensoObbligatorio) {
                  return consensoObbligatorio.esito === true;
                })

          } else {

            var ok =
              self.privacy &&
              self.privacy.documentPrivacyDownloaded &&
              allRadioChecked &&
              self.privacy.listaConsensi &&
              self.privacy.listaConsensi
                .filter(function (consenso) {
                  return !!consenso.obbligatorio;
                })
                .every(function (consensoObbligatorio) {
                  return consensoObbligatorio.esito === true;
                })

          }


        } else {

          var ok =
            self.privacy &&
            self.privacy.listaConsensi
              .filter(function (consenso) {
                return !!consenso.obbligatorio;
              })
              .every(function (consensoObbligatorio) {
                return consensoObbligatorio.esito === true;
              }) &&
            self.privacy.documentoPrivacyFirmato &&
            self.privacy.documentoPrivacyFirmato.nameFile;
        }
        if (ok) {
          self.onPrivacyOk && self.onPrivacyOk({
            privacy: self.privacy
          });
        } else {
          self.onPrivacyNotOk && self.onPrivacyNotOk();
        }
      };


      self.downloadPrivacy = function () {
        self.privacy.documentPrivacyDownloaded = true;
        self.checkPrivacy();
      }

      var mapConsensi = function () {
        self.privacy.listaConsensi = self.privacy.listaConsensi
          .map(function (element) {
            return {
              accepted: element.accepted,
              domanda: element.domanda,
              esito: element.esito,
              idModulo: element.idModulo,
              identifier: element.identifier,
              index: element.index,
              obbligatorio: element.obbligatorio,
              validFrom: element.validFrom,
              checked: false
            }
          })
      }

      self.checkRadio = function (index) {

        self.privacy.listaConsensi[index].checked = true;
        self.checkPrivacy();

      }

      self.setData = function (value) {
        self.privacy.dataSottoscrizione = value;
        self.checkPrivacy();
      }

    }
  });